import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

const soundchartsApi = axios.create({
  baseURL: "https://customer.api.soundcharts.com/api/v2",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_SNDCHARTS_API_KEY as string,
    "x-app-id": process.env.REACT_APP_SNDCHARTS_APP_ID as string,
  },
});

api.interceptors.request.use(
  (config) => {
    try {
      const authData = localStorage.getItem("auth");
      if (authData) {
        const auth = JSON.parse(authData);
        if (auth?.token) {
          config.headers.Authorization = `Bearer ${auth.token}`;
        }
      }
      return config;
    } catch (error) {
      console.error("Error parsing auth data:", error);
      return config;
    }
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem("auth");
      window.location.href = "/auth/login";
    }
    return Promise.reject(error);
  }
);

export { api, soundchartsApi };
